<template>
  <a-card :bordered="false">
    <app-warp title='会员卡'>
      <template #app-content>
        <div class="app-module">
          <div class="app-user-card" :style="{'background':'#D8D8D8 linear-gradient(315deg, rgba(252, 219, 161, 0.5) 0%, rgba(208, 126, 35, 0.5) 100%)'}">
            <div class="app-card-heard">
              <span class="app-card-name">一物一码数据服务</span>
              <img src="@/assets/images/index/logo.png" alt="" />
            </div>
            <div class="app-card-foot">
              <div class="app-card-foot-left">
                <img src="@/assets/images/user/v1.png" alt="" /><span class="app-card-leve">会员等级</span>
              </div>
              <div class="app-card-foot-right">完善个人资料></div>
            </div>
          </div>
        </div>
      </template>
      <template #app-sider>
        <div class="p-36">
          <a-form :model="form" ref='ruleForm' :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-item label="完善资料设置" :colon='false'></a-form-item>
            <a-divider />
            <a-form-item label="资料收集">
              <p class='m-t-32'></p>
              <a-table :columns="columns" :data-source="data">
              </a-table>
              <div class='ant-form-explain m-t-20'>若开启微信卡包、姓名、手机、生日为默认收集字段</div>
            </a-form-item>
            <a-form-item label="领卡奖励">
              <a-input-number v-model:value="form.vip_exp" class='m-r-10' :min='1' />成长值设置
            </a-form-item>
            <a-form-item label="打标签" name='instructions'>
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
              <a-button type="primary" @click="onSubmit"> 保存 </a-button>
            </a-form-item>
          </a-form>
        </div>
      </template>
    </app-warp>
  </a-card>
</template>
<script>
import { reactive, toRef, toRefs, watch, watchEffect, ref, inject } from "vue";
import { setMemberVip, getMemberVipDetail, editMemberVip } from "@/api/member";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
export default {
  setup(props) {
    const state = reactive({
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      form: {},
      columns: [
        {
          title: "字母名称",
          dataIndex: name,
          key: "name",
        },
        {
          title: "输入规则",
          key: "rule",
        },
        {
          title: "删除",
          key: "rule",
        },
      ],
      data: [],
    });
    const setOldMap = ref();
    const handleChoose = (data) => {
      state.form.background_map = `url(${data}) `;
      state.form.background = data;
    };
    const $router = inject("$router");
    const $route = inject("$route");
    if ($route.query.id) {
      getMemberVipDetail($route.query.id)
        .then((res) => {
          state.form = res.data.data;
        })
        .catch((error) => error);
    }
    // 保存
    const ruleForm = ref();

    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async (e) => {
          var background_map = state.form.background_map;
          if (state.form.is_upload == 2) {
            if (!state.form.background) {
              message.error("请选择背景图");
              return;
            } else {
              background_map = state.form.background;
            }
          }
          let result;
          if ($route.query.id) {
            result = await editMemberVip($route.query.id, {
              ...state.form,
              background_map: background_map,
            })
              .then((res) => res.data)
              .catch((error) => error);
          } else {
            result = await setMemberVip({
              ...state.form,
              background_map: background_map,
            })
              .then((res) => res.data)
              .catch((error) => error);
          }
          if (iscode(result, true)) {
            $router.go(-1);
          }
        })
        .catch((error) => {});
    };
    return {
      ...toRefs(state),
      handleChoose,
      ruleForm,
      onSubmit,
    };
  },
};
</script>
<style lang="less" scoped>
@import url("@/style/app-warp/app-warp.less");

.ant-checkbox-wrapper {
  width: 500px;
}
</style>